import { editor } from 'cplook'

const smsConfig = {
  browser_spellcheck: true,
  relative_urls: false,
  remove_script_host: false,
  plugins: [
    "searchreplace",
    "insertdatetime",
    "contextmenu",
    "paste",
    "cpliquid"
  ],
  toolbar: "undo redo, cpliquidselect",
  menu: {
    edit: {
      title: "Edit",
      items: "undo redo, selectall, searchreplace"
    },
    insert: {
      title: "Insert",
      items: "cpliquidmenu"
    }
  }
};

const emailConfig = {
  browser_spellcheck: true,
  relative_urls: false,
  remove_script_host: false,
  plugins: [
    "autolink",
    "lists",
    "link",
    "charmap",
    "searchreplace",
    "insertdatetime",
    "contextmenu",
    "paste",
    "preview",
    "code",
    "cpliquid",
    "image"
  ],
  toolbar:
    "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | image | cpliquidselect",
  menu: {
    edit: {
      title: "Edit",
      items: "undo redo | selectall | searchreplace"
    },
    insert: { title: "Insert", items: "link | image | cpliquidmenu" },
    view: { title: "View", items: "preview code" },
    format: { title: "Format", items: "formats | removeformat" }
  },
  style_formats: [
    {
      title: "Headers",
      items: [
        { title: "Header 1", format: "h1" },
        { title: "Header 2", format: "h2" },
        { title: "Header 3", format: "h3" },
        { title: "Header 4", format: "h4" },
        { title: "Header 5", format: "h5" },
        { title: "Header 6", format: "h6" }
      ]
    },
    {
      title: "Inline",
      items: [
        { title: "Bold", icon: "bold", format: "bold" },
        { title: "Italic", icon: "italic", format: "italic" },
        { title: "Underline", icon: "underline", format: "underline" },
        {
          title: "Strikethrough",
          icon: "strikethrough",
          format: "strikethrough"
        },
        {
          title: "Superscript",
          icon: "superscript",
          format: "superscript"
        },
        { title: "Subscript", icon: "subscript", format: "subscript" },
        { title: "Code", icon: "code", format: "code" }
      ]
    },
    {
      title: "Blocks",
      items: [
        { title: "Paragraph", format: "p" },
        { title: "Blockquote", format: "blockquote" },
        { title: "Div", format: "div" }
      ]
    },
    {
      title: "Alignment",
      items: [
        { title: "Left", icon: "alignleft", format: "alignleft" },
        { title: "Center", icon: "aligncenter", format: "aligncenter" },
        { title: "Right", icon: "alignright", format: "alignright" },
        {
          title: "Justify",
          icon: "alignjustify",
          format: "alignjustify"
        }
      ]
    }
  ],
  contextmenu: "link image inserttable | cell row column deletetable",
  paste_retain_style_properties: "color",
  paste_word_valid_elements:
    "a,b,blockquote,br,em,h1,h2,h3,h4,h5,h6,hr,i,li,ol,p,q,small,strong,sub,sup,u,ul",
  file_picker_types: "image",
  file_picker_callback: function(args) {
    editor.cp_file_picker.apply(this, arguments);
  },
  urlconverter_callback: function(args) {
    return editor.cp_url_converter.apply(this, arguments);
  }
};

const pageConfig = {
  browser_spellcheck: true,
  block_formats: "Paragraph=p;Blockquote=blockquote;Div=div",
  plugins: [
    "autolink",
    "lists",
    "link",
    "image",
    "charmap",
    "searchreplace",
    "insertdatetime",
    "contextmenu",
    "paste",
    "preview",
    "anchor",
    "visualblocks",
    "code",
    "media",
    "table",
    "preview",
    "hr",
    "visualchars",
    "nonbreaking",
    "textcolor",
    "cpliquid"
  ],
  toolbar:
    "undo redo | bold italic | fontsizeselect forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | charmap | link | image | cpliquidselect",
  menu: {
    edit: {
      title: "Edit",
      items: "undo redo | selectall | searchreplace"
    },
    insert: {
      title: "Insert",
      items: "link image media | charmap | hr | cpliquidmenu"
    },
    view: { title: "View", items: "visualaid | preview code" },
    format: { title: "Format", items: "formats | removeformat" },
    table: {
      title: "Table",
      items: "inserttable tableprops deletetable | cell row column"
    }
  },
  style_formats: [
    {
      title: "Headers",
      items: [
        { title: "Header 1", format: "h1" },
        { title: "Header 2", format: "h2" },
        { title: "Header 3", format: "h3" },
        { title: "Header 4", format: "h4" },
        { title: "Header 5", format: "h5" },
        { title: "Header 6", format: "h6" }
      ]
    },
    {
      title: "Inline",
      items: [
        { title: "Bold", icon: "bold", format: "bold" },
        { title: "Italic", icon: "italic", format: "italic" },
        { title: "Underline", icon: "underline", format: "underline" },
        {
          title: "Strikethrough",
          icon: "strikethrough",
          format: "strikethrough"
        },
        {
          title: "Superscript",
          icon: "superscript",
          format: "superscript"
        },
        { title: "Subscript", icon: "subscript", format: "subscript" },
        { title: "Code", icon: "code", format: "code" }
      ]
    },
    {
      title: "Blocks",
      items: [
        { title: "Paragraph", format: "p" },
        { title: "Blockquote", format: "blockquote" },
        { title: "Div", format: "div" }
      ]
    },
    {
      title: "Alignment",
      items: [
        { title: "Left", icon: "alignleft", format: "alignleft" },
        { title: "Center", icon: "aligncenter", format: "aligncenter" },
        { title: "Right", icon: "alignright", format: "alignright" },
        {
          title: "Justify",
          icon: "alignjustify",
          format: "alignjustify"
        }
      ]
    }
  ],
  contextmenu: "link image charmap | inserttable cell row column deletetable",
  paste_retain_style_properties: "color",
  paste_word_valid_elements:
    "a,b,blockquote,br,em,h1,h2,h3,h4,h5,h6,hr,i,li,ol,p,q,small,strong,sub,sup,u,ul",
  file_picker_types: "image",
  file_picker_callback: function(args) {
    editor.cp_file_picker.apply(this, arguments);
  },
  relative_urls: false,
  remove_script_host: false,
  urlconverter_callback: function(args) {
    return editor.cp_url_converter.apply(this, arguments);
  }
};

export default {
  default: emailConfig,
  email: emailConfig,
  sms: smsConfig,
  page: pageConfig
};
